import addNewTeamToExistingLeague from "./addNewTeamToExistingLeague.ts";
import avgAge from "./avgAge.ts";
import checkRosterSizes from "./checkRosterSizes.ts";
import deleteUnreadMessages from "./deleteUnreadMessages.ts";
import disable from "./disable.ts";
import ensureValidDivsConfs from "./ensureValidDivsConfs.ts";
import evaluatePointsFormula from "./evaluatePointsFormula.ts";
import expandVote from "./expandVote.ts";
import genSeasonRow from "./genSeasonRow.ts";
import genStatsRow from "./genStatsRow.ts";
import generate from "./generate.ts";
import genDepth from "./genDepth.ts";
import getContracts from "./getContracts.ts";
import getDepthPlayers from "./getDepthPlayers.ts";
import getPayroll from "./getPayroll.ts";
import getPayrolls from "./getPayrolls.ts";
import ovr from "./ovr.ts";
import processStats from "./processStats.ts";
import ptsMax from "./ptsMax.ts";
import ptsPct from "./ptsPct.ts";
import relocateVote from "./relocateVote.ts";
import resetTicketPrice from "./resetTicketPrice.ts";
import rosterAutoSort from "./rosterAutoSort.ts";
import switchTo from "./switchTo.ts";
import stats from "./stats.ts";
import updateClinchedPlayoffs from "./updateClinchedPlayoffs.ts";
import updateStrategies from "./updateStrategies.ts";

export default {
	addNewTeamToExistingLeague,
	avgAge,
	checkRosterSizes,
	deleteUnreadMessages,
	disable,
	ensureValidDivsConfs,
	evaluatePointsFormula,
	expandVote,
	genSeasonRow,
	genStatsRow,
	generate,
	genDepth,
	getContracts,
	getDepthPlayers,
	getPayroll,
	getPayrolls,
	ovr,
	processStats,
	ptsMax,
	ptsPct,
	relocateVote,
	resetTicketPrice,
	rosterAutoSort,
	switchTo,
	stats,
	updateClinchedPlayoffs,
	updateStrategies,
};
